/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ id: NonNullable<unknown> }} Agent_Builder_Model_UnavailableInputs */



/**
* | output |
* | --- |
* | "{id} (no longer available)" |
*
* @param {Agent_Builder_Model_UnavailableInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_builder_model_unavailable = /** @type {((inputs: Agent_Builder_Model_UnavailableInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Builder_Model_UnavailableInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.id} (nicht mehr verfügbar)`)
	return /** @type {LocalizedString} */ (`${i?.id} (no longer available)`)
});